module.exports = __webpack_public_path__ + "static/media/sneakpeak-02-old.7bab4aa7.jpg";